<script setup lang="ts">
const props = defineProps<{ contentType?: 'centered' | 'full-content' }>()

const computedClass = computed(() => {
  switch (props.contentType) {
    case 'centered':
      return 'self-center p-10'
    case 'full-content':
      return 'relative w-full flex justify-start mb-32 xl:mb-[4.2rem] items-start flex-col'
    default:
      return 'relative w-full flex justify-center mb-32 xl:mb-[4.2rem] items-center flex-col overflow-auto'
  }
})
</script>

<template>
  <div :class="computedClass">
    <slot />
  </div>
</template>
